import { render } from "./index.vue?vue&type=template&id=036fb094&scoped=true"
const script = {}

import "./index.vue?vue&type=style&index=0&id=036fb094&lang=less&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-036fb094"]])

export default __exports__